import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { LockExtensionDialogService } from '@libs/shared/ui/dialogs/lock-extension-dialog/lock-extension-dialog.service';
import { NgLetDirective } from '@libs/shared/utils/directives/ng-let/ng-let.directive';
import { LockExtensionDialogComponent } from './lock-extension-dialog.component';
import { SecondsToMinutesPipe } from '@libs/shared/utils/pipe/seconds-to-minutes/seconds-to-minutes.pipe';
import { LoadingSpinnerComponent } from '@libs/shared/ui/loading-spinner/loading-spinner.component';

@NgModule({
  declarations: [LockExtensionDialogComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    NgLetDirective,
    SecondsToMinutesPipe,
    LoadingSpinnerComponent,
  ],
  providers: [LockExtensionDialogService],
})
export class LockExtensionDialogModule {
  constructor(
    private _lockExtensionDialogService: LockExtensionDialogService
  ) {}
}
